import {Options, Vue} from "vue-class-component";
import {invoicesService} from "@services/invoices.service";
import {InvoiceTypeEnum} from "@/model/api/Invoice";
import {fileDownload, getFileNameFromHeader} from "@/utils/utils";
import {FilterMatchMode} from "primevue/api";
import {AppTable} from "@components";
import {Prop} from "vue-property-decorator";
import {Company} from "@/model/api/Company";

@Options({
    components: {
        AppTable
    }
})
export default class CompanyInvoices extends Vue {

    @Prop() readonly companyId!: String;

    @Prop() readonly company!: Company;

    filters: any = null;

    get service() {
        return invoicesService;
    }

    get typesOptions() {
        return Object.keys(InvoiceTypeEnum).map((key) => {
            return { label: this.$t(`invoices.type_${InvoiceTypeEnum[key]}`), value: InvoiceTypeEnum[key] }
        })
    }

    async downloadInvoices(id: number){
        this.$waitFor(
            async () => {
                const response = await invoicesService.downloadInvoices(id)
                try {
                    const fileName = getFileNameFromHeader(response.headers)
                    fileDownload(
                        fileName,
                        response.data,
                        response.headers['content-type']
                    )
                } catch (err) {
                    this.$errorMessage(this.$t('Operation failed'))
                }
            }
        );
    }



    created(){
        const companyType = (<string>this.$route.name).split('_')[0]

        this.filters = {
            [companyType.toLowerCase() + '_id']: {
                value: this.companyId,
                matchMode: FilterMatchMode.EQUALS
            },
            type : {
                value: InvoiceTypeEnum[companyType],
                matchMode: FilterMatchMode.EQUALS
            },
            business_zip: {
                value: null,
                matchMode: FilterMatchMode.CONTAINS
            },
            business_country: {
                value: null,
                matchMode: FilterMatchMode.CONTAINS
            },
            business_city: {
                value: null,
                matchMode: FilterMatchMode.CONTAINS
            },
            business_address: {
                value: null,
                matchMode: FilterMatchMode.CONTAINS
            },
            business_name: {
                value: null,
                matchMode: FilterMatchMode.CONTAINS
            },
            mov_id: {
                value: null,
                matchMode: FilterMatchMode.EQUALS
            }
        }
    }
}